var _g, _rect, _path, _rect2, _rect3, _rect4, _rect5, _ellipse, _ellipse2, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 102,
    viewBox: "0 0 139 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_649_27182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.7158,
    y: 3,
    width: 107.645,
    height: 72,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2158,
    y: 2.5,
    width: 108.645,
    height: 73,
    rx: 8.5,
    stroke: "#CCD5E2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.7158,
    y: 3,
    width: 107.645,
    height: 72,
    rx: 8,
    fill: "#E6F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7158 11C15.7158 6.58172 19.2975 3 23.7158 3H115.361C119.779 3 123.361 6.58172 123.361 11V55C123.361 57.2091 121.57 59 119.361 59H19.7158C17.5067 59 15.7158 57.2091 15.7158 55V11Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3271,
    y: 12,
    width: 25.8349,
    height: 30,
    rx: 2,
    fill: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_649_27182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 12,
    width: 27,
    height: 30
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3271,
    y: 12,
    width: 25.8349,
    height: 30,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_649_27182)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0977,
    y: 12,
    width: 32.2936,
    height: 30,
    fill: "#339999"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_649_27182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 12,
    width: 33,
    height: 30
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0977,
    y: 12,
    width: 32.2936,
    height: 30,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_649_27182)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.21,
    cx: 26.3453,
    cy: 14.7188,
    rx: 9.99083,
    ry: 9.28125,
    stroke: "white",
    strokeWidth: 3.75
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.21,
    cx: 51.8781,
    cy: 39.9375,
    rx: 13.1193,
    ry: 12.1875,
    stroke: "white",
    strokeWidth: 3.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0888 27.7188H40.4007L41.5842 40.75H32.9053L34.0888 27.7188Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_649_27182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 27,
    width: 10,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0888 27.7188H40.4007L41.5842 40.75H32.9053L34.0888 27.7188Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_649_27182)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8362 28.9602C33.8362 28.9602 34.539 30.8359 37.1928 31.2537C39.8466 31.6714 41.367 31.2537 41.367 31.2537L40.8111 28L33.5811 28.0313L33.8362 28.9602Z",
    fill: "#339999"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3686 37.7107C23.8444 36.0585 25.0735 34.7287 26.6832 34.1246L33.7769 31.4624C33.7769 31.4624 35.6429 35.8704 37.2441 35.8704C38.8452 35.8704 40.7259 31.4624 40.7259 31.4624L47.807 34.1239C49.4155 34.7285 50.6435 36.0578 51.1191 37.709L52.3817 42.0936H22.1064L23.3686 37.7107Z",
    fill: "url(#paint0_linear_649_27182)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_649_27182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 31,
    width: 31,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3686 37.7107C23.8444 36.0585 25.0735 34.7287 26.6832 34.1246L33.7769 31.4624C33.7769 31.4624 35.6429 35.8704 37.2441 35.8704C38.8452 35.8704 40.7259 31.4624 40.7259 31.4624L47.807 34.1239C49.4155 34.7285 50.6435 36.0578 51.1191 37.709L52.3817 42.0936H22.1064L23.3686 37.7107Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_649_27182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.042,
    y: 35.1562,
    width: 0.40367,
    height: 7.03125,
    fill: "#BECAE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7852 42.0936L29.1651 39.7905L28.1338 42.0936H28.7852Z",
    fill: "#BECAE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5781 42.0936L46.1982 39.7905L47.2295 42.0936H46.5781Z",
    fill: "#BECAE4"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5843 32.4675C31.5502 32.3304 31.6242 32.1901 31.7562 32.1397L33.7448 31.3789C34.9133 34.2443 36.0513 35.658 36.9415 35.8354C36.9415 35.8354 36.1939 38.6718 35.5688 38.8775C35.2806 38.9724 33.5185 37.9107 32.5041 35.5796C32.1927 34.864 31.7437 33.1088 31.5843 32.4675Z",
    fill: "#339999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8952 32.4675C42.9293 32.3304 42.8553 32.1901 42.7233 32.1397L40.7347 31.3789C39.5662 34.2443 38.4282 35.658 37.538 35.8354C37.538 35.8354 38.2856 38.6718 38.9107 38.8775C39.1989 38.9724 40.961 37.9107 41.9754 35.5796C42.2868 34.864 42.7358 33.1088 42.8952 32.4675Z",
    fill: "#339999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4009 17.3438H42.6945C42.6945 17.3438 42.675 23.7108 42.4926 26.0322C42.2939 28.5609 39.98 30.1875 37.4434 30.1875H33.9378C33.5863 30.1875 33.2677 30.0702 33.1559 29.7369C32.9901 29.2424 32.7735 28.2056 32.6027 26.0322C32.2805 21.9316 32.4009 17.3438 32.4009 17.3438Z",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.8223,
    cy: 25.2124,
    rx: 0.908257,
    ry: 0.421875,
    fill: "#FDE0D5"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3731,
    cy: 25.2124,
    rx: 0.908257,
    ry: 0.421875,
    fill: "#FDE0D5"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.2764,
    cy: 23.2969,
    rx: 0.454128,
    ry: 0.421875,
    fill: "#339999"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.919,
    cy: 23.2969,
    rx: 0.454128,
    ry: 0.421875,
    fill: "#339999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4297 18.1216C33.4297 18.1216 33.9379 20.1151 36.2575 19.8375C38.577 19.5599 39.9191 17.09 42.0997 19.2278C42.0997 19.2278 40.7253 16.4304 37.6651 16.7653C34.605 17.1002 33.4297 18.1216 33.4297 18.1216Z",
    fill: "#339999"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4297 18.1216C33.4297 18.1216 33.8219 19.214 35.8607 19.5599",
    stroke: "#339999",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4005 23.7187C32.4005 23.7187 29.2388 17.1973 32.9696 16.2099C32.9696 16.2099 33.1193 13.6192 35.5309 13.5457C37.9425 13.4722 38.335 14.2051 40.4006 14.4622C42.4661 14.7194 44.0409 16.5746 44.0409 18.7528C44.0409 20.931 42.6941 23.7187 42.6941 23.7187C42.6941 23.7187 42.9109 18.665 40.6349 18.1216C38.3589 17.5782 37.6974 18.89 36.2182 18.89C34.7389 18.89 33.4295 18.0515 33.4295 18.0515C33.4295 18.0515 33.3779 19.1637 33.1612 20.3576C32.9444 21.5515 32.4005 23.7187 32.4005 23.7187Z",
    fill: "#339999"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1387 21.7662C34.1387 21.7662 35.054 21.1893 36.0677 21.5601",
    stroke: "#339999",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1143 21.7662C41.1143 21.7662 40.1989 21.1893 39.1852 21.5601",
    stroke: "#339999",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5246 23.574C42.5246 23.574 43.2277 21.9158 44.298 22.9219C45.3683 23.928 44.1232 26.7239 42.374 25.7838L42.5246 23.574Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1113 24.816C43.2432 24.0216 43.4829 23.5529 43.8304 23.4102",
    stroke: "#CCD4E6",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.536 23.574C32.536 23.574 31.8329 21.9158 30.7626 22.9219C29.6923 23.928 30.9374 26.7239 32.6865 25.7838L32.536 23.574Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9492 24.816C31.8174 24.0216 31.5777 23.5529 31.2302 23.4102",
    stroke: "#CCD4E6",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5377 21.749C37.5377 21.749 37.5377 22.1237 37.5377 22.7219C37.5377 23.3201 38.8826 25.2191 38.0106 25.4557C37.1385 25.6923 37.1426 25.6766 37.1426 25.6766",
    stroke: "#CCD4E6",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2959 27.3853C36.2959 27.3853 37.8375 28.0523 38.9827 27.3853",
    stroke: "#CCD4E6",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6211,
    y: 14,
    width: 20.4526,
    height: 1,
    rx: 0.5,
    fill: "#339999"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7617,
    y: 50,
    width: 27.9878,
    height: 1,
    rx: 0.5,
    fill: "#CCD5E2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6211,
    y: 24,
    width: 11.841,
    height: 1,
    rx: 0.5,
    fill: "#339999"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6211,
    y: 34,
    width: 11.841,
    height: 1,
    rx: 0.5,
    fill: "#339999"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 73.8438,
    y: 34,
    width: 8.61162,
    height: 1,
    rx: 0.5,
    fill: "#339999"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 56.6211,
    y: 17,
    width: 27.9878,
    height: 2.5,
    rx: 1.25,
    fill: "#339999"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 88.9141,
    y: 17,
    width: 23.682,
    height: 2.5,
    rx: 1.25,
    fill: "#339999"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 56.6211,
    y: 27,
    width: 21.5291,
    height: 2.5,
    rx: 1.25,
    fill: "#339999"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 56.6211,
    y: 37,
    width: 9.68807,
    height: 2.5,
    rx: 1.25,
    fill: "#339999"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 56.6211,
    y: 47,
    width: 4.30581,
    height: 4,
    rx: 1,
    fill: "#339999"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 62.0029,
    y: 47,
    width: 4.30581,
    height: 4,
    rx: 1,
    fill: "#339999"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 67.3857,
    y: 47,
    width: 4.30581,
    height: 4,
    rx: 1,
    fill: "#339999"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 72.7676,
    y: 47,
    width: 4.30581,
    height: 4,
    rx: 1,
    fill: "#339999"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 73.8438,
    y: 37,
    width: 6.45872,
    height: 2.5,
    rx: 1.25,
    fill: "#339999"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9912 48C89.9912 48 95.8327 46.7347 95.2982 45.4711C94.7637 44.2075 92.9509 45.6329 94.6431 48L98.1197 45.8855L97.1849 48C97.1849 48 99.9941 47.867 101.182 46.553C102.369 45.239 101.359 48 102.263 48C103.166 48 106.375 46.553 105.226 45.4711C104.077 44.3892 102.486 48 105.226 48C107.966 48 111.52 45.4711 111.52 45.4711",
    stroke: "#339999",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6189 63L24.3271 64.25L25.6189 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8054 63L27.5137 64.25L28.8054 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9919 63L30.7002 64.25L31.9919 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1775 63L33.8857 64.25L35.1775 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.364 63L37.0723 64.25L38.364 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5505 63L40.2588 64.25L41.5505 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7361 63L43.4443 64.25L44.7361 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9226 63L46.6309 64.25L47.9226 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1091 63L49.8174 64.25L51.1091 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2956 63L53.0039 64.25L54.2956 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4812 63L56.1895 64.25L57.4812 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6677 63L59.376 64.25L60.6677 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8542 63L62.5625 64.25L63.8542 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0417 63L65.75 64.25L67.0417 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2273 63L68.9355 64.25L70.2273 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4138 63L72.1221 64.25L73.4138 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 63L75.3086 64.25L76.6003 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7869 63L78.4951 64.25L79.7869 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9724 63L81.6807 64.25L82.9724 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1589 63L84.8672 64.25L86.1589 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3455 63L88.0537 64.25L89.3455 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M92.531 63L91.2393 64.25L92.531 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7175 63L94.4258 64.25L95.7175 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98.904 63L97.6123 64.25L98.904 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M102.091 63L100.799 64.25L102.091 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M105.276 63L103.984 64.25L105.276 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M108.463 63L107.171 64.25L108.463 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M111.649 63L110.357 64.25L111.649 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M114.836 63L113.544 64.25L114.836 65.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6189 68L24.3271 69.25L25.6189 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8054 68L27.5137 69.25L28.8054 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9919 68L30.7002 69.25L31.9919 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1775 68L33.8857 69.25L35.1775 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.364 68L37.0723 69.25L38.364 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5505 68L40.2588 69.25L41.5505 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7361 68L43.4443 69.25L44.7361 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9226 68L46.6309 69.25L47.9226 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1091 68L49.8174 69.25L51.1091 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2956 68L53.0039 69.25L54.2956 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4812 68L56.1895 69.25L57.4812 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6677 68L59.376 69.25L60.6677 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8542 68L62.5625 69.25L63.8542 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0417 68L65.75 69.25L67.0417 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2273 68L68.9355 69.25L70.2273 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4138 68L72.1221 69.25L73.4138 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 68L75.3086 69.25L76.6003 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7869 68L78.4951 69.25L79.7869 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9724 68L81.6807 69.25L82.9724 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1589 68L84.8672 69.25L86.1589 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3455 68L88.0537 69.25L89.3455 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M92.531 68L91.2393 69.25L92.531 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7175 68L94.4258 69.25L95.7175 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M98.904 68L97.6123 69.25L98.904 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M102.091 68L100.799 69.25L102.091 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M105.276 68L103.984 69.25L105.276 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M108.463 68L107.171 69.25L108.463 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M111.649 68L110.357 69.25L111.649 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M114.836 68L113.544 69.25L114.836 70.5",
    stroke: "white",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.185 46.9061C101.316 46.9061 101.447 46.9173 101.577 46.9449C101.977 47.03 102.317 47.2706 102.648 47.5035C102.958 47.7229 103.279 47.9499 103.547 47.9499C103.814 47.9499 104.135 47.7229 104.446 47.5035C104.776 47.2706 105.117 47.03 105.517 46.9449C105.932 46.8561 106.36 46.9361 106.774 47.0132C107.147 47.0823 107.533 47.1543 107.757 47.0532C107.99 46.9481 108.172 46.6164 108.349 46.2958C108.54 45.9486 108.737 45.5893 109.063 45.3455C109.391 45.1001 109.811 44.9994 110.217 44.9015C110.589 44.812 110.973 44.7193 111.133 44.5331C111.29 44.3484 111.302 43.9788 111.312 43.6211C111.324 43.2278 111.337 42.821 111.52 42.4653C111.7 42.1173 112.029 41.8583 112.347 41.6081C112.643 41.3747 112.949 41.1333 113.008 40.8948C113.062 40.6722 112.902 40.3389 112.748 40.0164C112.574 39.6531 112.394 39.2774 112.394 38.8746C112.394 38.4718 112.574 38.0961 112.748 37.7328C112.902 37.4103 113.062 37.077 113.007 36.8544C112.949 36.6155 112.642 36.3741 112.346 36.1407C112.028 35.8905 111.7 35.632 111.52 35.2835C111.337 34.9274 111.324 34.521 111.312 34.1281C111.301 33.7705 111.29 33.4004 111.132 33.2158C110.973 33.0295 110.589 32.9368 110.217 32.8473C109.811 32.7498 109.391 32.6487 109.062 32.4033C108.736 32.1599 108.539 31.8006 108.348 31.453C108.171 31.1325 107.989 30.8012 107.757 30.6961C107.532 30.5953 107.146 30.6669 106.773 30.736C106.359 30.8127 105.93 30.8923 105.517 30.8044C105.117 30.7196 104.776 30.4787 104.446 30.2461C104.135 30.0263 103.814 29.7993 103.547 29.7993C103.279 29.7993 102.958 30.0263 102.647 30.2461C102.317 30.4787 101.976 30.7196 101.576 30.8044C101.161 30.8931 100.733 30.8127 100.32 30.7364C99.9462 30.6669 99.5604 30.5953 99.3361 30.6961C99.1032 30.8012 98.9212 31.1329 98.7448 31.4534C98.5538 31.801 98.356 32.1603 98.03 32.4037C97.7023 32.6487 97.2819 32.7502 96.8756 32.8477C96.5043 32.9372 96.1203 33.0299 95.9605 33.2166C95.8033 33.4012 95.7917 33.7705 95.781 34.1281C95.7686 34.5214 95.7563 34.9282 95.5725 35.2839C95.3927 35.6324 95.0646 35.8909 94.7467 36.1411C94.4502 36.3745 94.1443 36.6155 94.0862 36.8544C94.0319 37.0774 94.1913 37.4107 94.3455 37.7328C94.519 38.0965 94.6988 38.4718 94.6988 38.8746C94.6988 39.2774 94.519 39.6531 94.3455 40.0164C94.1913 40.3389 94.0319 40.6722 94.0862 40.8952C94.1443 41.1337 94.4502 41.3751 94.7471 41.6085C95.065 41.8587 95.3931 42.1177 95.573 42.4661C95.7567 42.8214 95.7691 43.2282 95.7815 43.6211C95.7921 43.9788 95.8033 44.3488 95.9609 44.5335C96.1203 44.7197 96.5048 44.8124 96.8765 44.9019C97.2824 44.9994 97.7028 45.1005 98.0309 45.3459C98.3569 45.5893 98.5547 45.9486 98.7452 46.2962C98.9217 46.6168 99.1041 46.9481 99.3365 47.0532C99.5604 47.1543 99.9462 47.0827 100.32 47.0132C100.605 46.9604 100.896 46.9061 101.185 46.9061ZM103.546 48.7492C102.993 48.7492 102.536 48.4263 102.133 48.1414C101.875 47.9595 101.608 47.7713 101.387 47.7241C101.149 47.6734 100.812 47.7365 100.486 47.7973C99.999 47.8876 99.4462 47.9903 98.9651 47.7729C98.4747 47.5519 98.2149 47.0787 97.9855 46.6615C97.8355 46.389 97.6804 46.1072 97.4976 45.9705C97.3126 45.8323 96.9823 45.7527 96.6632 45.676C96.1791 45.5593 95.6305 45.427 95.2934 45.0322C94.9576 44.6386 94.9414 44.1102 94.9269 43.6443C94.9175 43.3349 94.9076 43.0152 94.8034 42.813C94.703 42.6188 94.4458 42.4162 94.1967 42.22C93.8109 41.9166 93.3743 41.5726 93.253 41.0722C93.1355 40.589 93.3636 40.1115 93.5653 39.6899C93.7024 39.4033 93.8443 39.1068 93.8443 38.8746C93.8443 38.6424 93.7024 38.3463 93.5653 38.0598C93.3636 37.6381 93.135 37.1602 93.253 36.6774C93.3743 36.1771 93.8109 35.833 94.1967 35.5297C94.4454 35.3334 94.7026 35.1308 94.803 34.9362C94.9076 34.7344 94.917 34.4147 94.9269 34.105C94.941 33.639 94.9572 33.1111 95.293 32.7178C95.6301 32.3226 96.1787 32.1903 96.6627 32.074C96.9819 31.9969 97.3117 31.9177 97.4967 31.7791C97.68 31.6424 97.8347 31.3607 97.985 31.0877C98.2145 30.6709 98.4742 30.1977 98.9647 29.9763C99.4462 29.7593 99.9986 29.8612 100.486 29.9523C100.813 30.0127 101.149 30.075 101.387 30.0251C101.608 29.9783 101.874 29.7901 102.132 29.6078C102.536 29.3229 102.993 29 103.546 29C104.1 29 104.557 29.3229 104.961 29.6078C105.218 29.7897 105.485 29.9779 105.706 30.0251C105.942 30.075 106.281 30.0131 106.607 29.9519C107.094 29.8612 107.647 29.7585 108.128 29.9763C108.618 30.1973 108.878 30.6705 109.107 31.0873C109.257 31.3603 109.412 31.642 109.596 31.7787C109.781 31.9173 110.111 31.9965 110.43 32.0732C110.914 32.1899 111.463 32.3218 111.8 32.717C112.136 33.1103 112.152 33.639 112.166 34.105C112.176 34.4143 112.186 34.734 112.289 34.9362C112.39 35.1304 112.647 35.333 112.897 35.5293C113.282 35.8326 113.719 36.1763 113.84 36.677C113.957 37.1598 113.729 37.6377 113.528 38.059C113.39 38.3459 113.249 38.6424 113.249 38.8746C113.249 39.1068 113.39 39.4033 113.528 39.6899C113.729 40.1115 113.957 40.589 113.841 41.0718C113.719 41.5722 113.282 41.9162 112.897 42.2196C112.648 42.4158 112.391 42.6184 112.29 42.813C112.186 43.0148 112.176 43.3345 112.166 43.6443C112.152 44.1102 112.136 44.6382 111.8 45.0318C111.463 45.4266 110.914 45.5589 110.43 45.6756C110.111 45.7523 109.781 45.8319 109.596 45.9701C109.413 46.1068 109.258 46.3886 109.108 46.6615C108.879 47.0787 108.619 47.5515 108.129 47.7725C107.647 47.9903 107.094 47.8872 106.607 47.7969C106.281 47.7365 105.943 47.6734 105.707 47.7241C105.485 47.7713 105.219 47.9591 104.961 48.1414C104.558 48.4263 104.1 48.7492 103.546 48.7492Z",
    fill: "#FF7C00"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.668 44.2065C101.745 44.2065 101.821 44.2135 101.897 44.2291C102.25 44.3022 102.513 44.5502 102.766 44.79C102.906 44.9232 103.142 45.1467 103.243 45.1467C103.344 45.1467 103.58 44.9232 103.72 44.79C103.973 44.5502 104.236 44.3022 104.589 44.2288C104.953 44.1542 105.331 44.2811 105.665 44.394C105.826 44.4483 106.157 44.5604 106.239 44.5268C106.324 44.4893 106.433 44.1881 106.491 44.026C106.605 43.7065 106.724 43.3765 107.012 43.1679C107.3 42.9581 107.699 42.9249 108.052 42.8956C108.237 42.88 108.583 42.8511 108.641 42.7851C108.698 42.7206 108.652 42.4093 108.628 42.2422C108.581 41.9226 108.529 41.5609 108.69 41.2571C108.849 40.9582 109.175 40.7805 109.49 40.609C109.652 40.5208 109.953 40.3567 109.975 40.2704C109.992 40.1923 109.806 39.9357 109.707 39.7978C109.51 39.5259 109.287 39.2173 109.287 38.8744C109.287 38.5314 109.51 38.2233 109.706 37.9514C109.806 37.8135 109.991 37.5569 109.974 37.478C109.953 37.3921 109.652 37.228 109.49 37.1401C109.175 36.9682 108.848 36.7909 108.69 36.4921C108.529 36.1882 108.581 35.8261 108.627 35.507C108.652 35.3394 108.698 35.0281 108.641 34.9637C108.583 34.8977 108.237 34.8688 108.051 34.8531C107.699 34.8238 107.3 34.7906 107.011 34.5809C106.723 34.3723 106.605 34.0423 106.49 33.7227C106.432 33.561 106.324 33.2599 106.239 33.2224C106.161 33.1876 105.825 33.3005 105.665 33.3548C105.331 33.4677 104.953 33.595 104.589 33.52C104.236 33.447 103.973 33.1989 103.72 32.9591C103.58 32.8255 103.344 32.6025 103.243 32.6025C103.142 32.6025 102.906 32.8255 102.766 32.9591C102.513 33.1989 102.25 33.4474 101.896 33.5204C101.534 33.595 101.155 33.4677 100.821 33.3548C100.66 33.3005 100.327 33.1888 100.247 33.2224C100.161 33.2599 100.053 33.5614 99.9949 33.7235C99.8805 34.0426 99.7619 34.3727 99.4747 34.5809C99.1862 34.791 98.7868 34.8242 98.4343 34.8535C98.249 34.8692 97.9029 34.8981 97.8448 34.9641C97.7885 35.0285 97.8337 35.3398 97.8582 35.507C97.9046 35.8261 97.9575 36.1882 97.7958 36.4921C97.6372 36.7909 97.3109 36.9686 96.9957 37.1401C96.8337 37.2284 96.5327 37.3924 96.5108 37.4788C96.4944 37.5569 96.6797 37.8131 96.7795 37.951C96.9764 38.2233 97.1991 38.5314 97.1991 38.8744C97.1991 39.2177 96.9764 39.5259 96.7795 39.7982C96.6797 39.936 96.4944 40.1927 96.5112 40.2712C96.5327 40.3571 96.8337 40.5208 96.9957 40.609C97.3109 40.7805 97.6372 40.9582 97.7963 41.2571C97.9575 41.5609 97.905 41.9226 97.8586 42.2422C97.8341 42.4093 97.789 42.721 97.8453 42.7855C97.9033 42.8515 98.2494 42.88 98.4347 42.896C98.7872 42.9253 99.1866 42.9585 99.4751 43.1679C99.7623 43.3765 99.881 43.7069 99.9953 44.0264C100.054 44.1881 100.162 44.4897 100.247 44.5268C100.327 44.5619 100.661 44.4491 100.822 44.3944C101.086 44.3049 101.377 44.2065 101.668 44.2065ZM103.243 45.9279C102.775 45.9279 102.44 45.6107 102.145 45.3306C102.003 45.1963 101.808 45.0119 101.706 44.9908C101.59 44.9674 101.32 45.0592 101.121 45.1264C100.728 45.2592 100.282 45.4095 99.8732 45.2306C99.4574 45.0482 99.3091 44.6338 99.178 44.2682C99.1135 44.0877 99.0249 43.8409 98.9385 43.7784C98.8508 43.7151 98.5649 43.6913 98.3564 43.6737C97.9359 43.6386 97.46 43.5987 97.1736 43.273C96.8886 42.948 96.9505 42.5187 97.006 42.1394C97.0339 41.95 97.0717 41.6898 97.0219 41.5965C96.975 41.5082 96.7317 41.3758 96.5537 41.2793C96.1891 41.0809 95.7759 40.8559 95.6728 40.4442C95.5726 40.0442 95.8323 39.6857 96.061 39.3693C96.1848 39.1974 96.3392 38.9838 96.3392 38.8744C96.3392 38.765 96.1848 38.5514 96.061 38.3799C95.8323 38.0635 95.5726 37.7049 95.6723 37.3057C95.7759 36.8936 96.1891 36.6687 96.5533 36.4702C96.7312 36.3734 96.9746 36.2409 97.0214 36.1527C97.0713 36.0593 97.0335 35.7992 97.0055 35.6093C96.9505 35.2305 96.8882 34.8012 97.1732 34.4766C97.4595 34.1508 97.9355 34.111 98.3555 34.0758C98.5645 34.0583 98.8504 34.0344 98.9381 33.9708C99.0245 33.9083 99.113 33.6614 99.1775 33.4813C99.3091 33.1154 99.4574 32.7009 99.8732 32.5189C100.283 32.34 100.728 32.49 101.121 32.6228C101.32 32.69 101.596 32.7814 101.706 32.7583C101.808 32.7373 102.003 32.5529 102.145 32.4181C102.44 32.1385 102.775 31.8213 103.243 31.8213C103.711 31.8213 104.046 32.1385 104.341 32.4181C104.483 32.5529 104.678 32.7373 104.779 32.7583C104.893 32.7798 105.166 32.6896 105.365 32.6228C105.758 32.4896 106.203 32.3388 106.612 32.5189C107.028 32.7005 107.176 33.115 107.307 33.481C107.372 33.661 107.461 33.9079 107.547 33.9704C107.635 34.034 107.921 34.0579 108.129 34.0755C108.55 34.1106 109.026 34.1501 109.312 34.4762C109.597 34.8008 109.535 35.2305 109.48 35.6093C109.452 35.7992 109.415 36.0593 109.464 36.1527C109.511 36.2406 109.754 36.373 109.932 36.4698C110.297 36.6683 110.71 36.8933 110.813 37.3049C110.913 37.7045 110.654 38.0635 110.425 38.3799C110.301 38.5517 110.147 38.765 110.147 38.8744C110.147 38.9838 110.301 39.1974 110.425 39.3689C110.654 39.6853 110.913 40.0442 110.814 40.4434C110.71 40.8555 110.297 41.0805 109.933 41.2789C109.755 41.3754 109.511 41.5082 109.464 41.5965C109.415 41.6898 109.452 41.95 109.48 42.1394C109.535 42.5187 109.598 42.948 109.313 43.2722C109.026 43.5983 108.55 43.6382 108.13 43.6733C107.921 43.6909 107.635 43.7147 107.548 43.7784C107.461 43.8409 107.373 44.0877 107.308 44.2682C107.177 44.6338 107.028 45.0482 106.613 45.2303C106.203 45.4095 105.758 45.2596 105.365 45.1264C105.166 45.0592 104.891 44.9678 104.779 44.9904C104.678 45.0119 104.483 45.1959 104.341 45.3306C104.046 45.6107 103.711 45.9279 103.243 45.9279Z",
    fill: "#FF7C00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_649_27182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 29,
    width: 21,
    height: 25
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2207 53.8278H113.872V29.5645H93.2207V53.8278Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_649_27182)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6875 38.0281H107.799V37.4639H98.6875V38.0281Z",
    fill: "#FF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6875 39.1565H107.799V38.5923H98.6875V39.1565Z",
    fill: "#FF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6875 40.8494H107.799V40.2852H98.6875V40.8494Z",
    fill: "#FF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.243 36.0207C101.549 36.0207 100.171 37.3011 100.171 38.8747C100.171 40.4484 101.549 41.7288 103.243 41.7288C104.937 41.7288 106.315 40.4484 106.315 38.8747C106.315 37.3011 104.937 36.0207 103.243 36.0207ZM103.243 42.5425C101.066 42.5425 99.2949 40.8972 99.2949 38.8747C99.2949 36.8523 101.066 35.207 103.243 35.207C105.42 35.207 107.191 36.8523 107.191 38.8747C107.191 40.8972 105.42 42.5425 103.243 42.5425Z",
    fill: "#FF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4727 53.8274H109.013V53.2632H97.4727V53.8274Z",
    fill: "#FF7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6504 51.0062H110.835V50.4419H95.6504V51.0062Z",
    fill: "#FF7C00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_649_27182",
    x: 0.71582,
    y: 0,
    width: 137.646,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_649_27182"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.184314 0 0 0 0 0.439216 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_649_27182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_649_27182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_27182",
    x1: 22.1064,
    y1: 31.4624,
    x2: 22.1064,
    y2: 42.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E8ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/Passport.902c285fb0cc169a4c4e0eb129e7a46f.svg";
export { ForwardRef as ReactComponent };